// extracted by mini-css-extract-plugin
export var buttonContainer = "_5d-1";
export var fontSizeSelect = "_5d-3";
export var formatSelect = "_5d-2";
export var formats = "_5d-4";
export var hidden = "_5d-5";
export var icon = "_5d-6";
export var select = "_5d-0";